import { useParams } from 'react-router-dom';

import { GlobalTypes, useStore } from '@modules';

const useDefaultCurrency = (): GlobalTypes.CryptoCurrencyEnum => {
  const params = useParams<{ currency?: GlobalTypes.CryptoCurrencyEnum }>();
  const [{ global }] = useStore();
  const defaultCurrency = global.currencies.crypto[0];

  return params.currency || defaultCurrency;
};

export default useDefaultCurrency;
